import React from 'react';
import { Tabs, Card, Typography } from 'antd';
import { FileTextOutlined, CheckCircleOutlined, AlertOutlined } from '@ant-design/icons';
import CheckSignTab from './CheckSignTab';
import CanhBaoTab from './CanhBaoTab';

const { Title } = Typography;

const HSBAPage: React.FC = () => {
  // Hàm kiểm tra quyền từ localStorage
  const hasPermission = (permission: string) => {
    const storedPermissions = localStorage.getItem('permissions');
    if (!storedPermissions) return false;
    try {
      const permissionsList: string[] = JSON.parse(storedPermissions);
      return permissionsList.includes(permission);
    } catch (e) {
      return false;
    }
  };

  // Cấu trúc danh sách các tab trong Hồ sơ bệnh án
  const items = [];

  // Tab Kiểm tra chữ ký số - chỉ hiển thị nếu có quyền CheckSign
  if (hasPermission('CheckSign')) {
    items.push({
      key: 'check-sign',
      label: (
        <span>
          <CheckCircleOutlined />
          Kiểm tra chữ ký số
        </span>
      ),
      children: <CheckSignTab />,
    });
  }

  // Tab Cảnh báo - chỉ hiển thị nếu có quyền Canhbao
  if (hasPermission('Canhbao')) {
    items.push({
      key: 'canh-bao',
      label: (
        <span>
          <AlertOutlined />
          Cảnh báo
        </span>
      ),
      children: <CanhBaoTab />,
    });
  }

  // Bạn có thể dễ dàng thêm các tab khác vào đây trong tương lai
  /*
  if (hasPermission('OtherPermission')) {
    items.push({
      key: 'other-feature',
      label: 'Chức năng khác',
      children: <OtherComponent />,
    });
  }
  */

  // Nếu không có quyền HSBA thì App.tsx đã chặn ở mức Route.
  // Ở đây kiểm tra thêm nếu không có chức năng con nào được phép xem.
  if (items.length === 0) {
    return (
      <Card style={{ margin: '24px', textAlign: 'center' }}>
        <Title level={4}>Bạn không có quyền truy cập các chức năng con trong Hồ sơ bệnh án</Title>
      </Card>
    );
  }

  return (
    <div className="hsba-page" style={{ padding: '24px' }}>
      <Card bordered={false} className="hsba-container">
        <Title level={3} style={{ marginBottom: '24px' }}>
          <FileTextOutlined style={{ marginRight: '8px' }} />
          Hồ sơ bệnh án
        </Title>
        <Tabs 
          defaultActiveKey="check-sign" 
          items={items} 
          type="card"
          size="large"
        />
      </Card>
    </div>
  );
};

export default HSBAPage;
